import { TagTypes } from '@monorepo/base/src/components/tag/tag';
// import { Colors } from './colors';

export interface IStatus {
	status?: Status;
}

export enum Statuses {
	Active = 'ACTIVE',
	Paused = 'PAUSED',
	NoBalance = 'NO BALANCE',
	New = 'NEW',
	Ended = 'ENDED',
	DealServingStatusUnspecified = 'DEAL_SERVING_STATUS_UNSPECIFIED',
	PausedByBuyer = 'PAUSED_BY_BUYER',
	PausedBySeller = 'PAUSED_BY_SELLER',
}

export type Status =
	| Statuses.Active
	| Statuses.Paused
	| Statuses.NoBalance
	| Statuses.New
	| Statuses.Ended
	| Statuses.DealServingStatusUnspecified
	| Statuses.PausedByBuyer
	| Statuses.PausedBySeller;

// export const mapToColor = (status?: Status) => {
// 	if (status === Statuses.Active) {
// 		return Colors.Success;
// 	}
// 	if (status === Statuses.New) {
// 		return Colors.New;
// 	}
// 	if (status === Statuses.NoBalance) {
// 		return Colors.Warning;
// 	}
// 	if (status === Statuses.Paused) {
// 		return Colors.Error;
// 	}
// 	return Colors.Info;
// };

export const mapToTagStatus = (status?: Status) => {
	if (status === Statuses.Active) {
		return TagTypes.Success;
	}
	if (status === Statuses.New) {
		return TagTypes.New;
	}
	if (status === Statuses.NoBalance) {
		return TagTypes.Warning;
	}
	if (status === Statuses.Paused) {
		return TagTypes.Paused;
	}
	if (status === Statuses.Ended) {
		return TagTypes.Deleted;
	}
	if (status === Statuses.DealServingStatusUnspecified) {
		return TagTypes.Info;
	}
	if (status === Statuses.PausedByBuyer) {
		return TagTypes.Warning;
	}
	if (status === Statuses.PausedBySeller) {
		return TagTypes.Warning;
	}
	return TagTypes.Info;
};

export const mapToIcon = (status: Status) => {
	if (status === Statuses.Active) {
		return 'play';
	}
	if (status === Statuses.New) {
		return 'message-plus-circle';
	}
	if (status === Statuses.NoBalance) {
		return 'credit-card-x';
	}
	if (status === Statuses.Paused) {
		return 'pause-square';
	}
	if (status === Statuses.DealServingStatusUnspecified) {
		return 'info-circle';
	}
	if (status === Statuses.PausedByBuyer) {
		return 'user-pause';
	}
	if (status === Statuses.PausedBySeller) {
		return 'store-pause';
	}
	return 'info-circle';
};
